import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { preloadRoute } from './App';
import { hydration } from './site/session';

// Public pages are prerendered into the HTML at build time (scripts/prerender.js): hydrate that
// markup instead of replacing it. Every other URL arrives with an empty #root.
function HydrationDone({ children }) {
  useEffect(() => { hydration.active = false; }, []);
  return children;
}

const container = document.getElementById('root');
// StrictMode stays off: it double-renders in development, which resets Stripe's PaymentElement.
if (container.firstElementChild) {
  hydration.active = true;
  // Some prerendered pages are in their own code file: load it first so hydration finds the page.
  // If it fails to load, hydrate anyway (React then renders the page from scratch).
  const hydrate = () => ReactDOM.hydrateRoot(container, <HydrationDone><App /></HydrationDone>);
  preloadRoute(container.getAttribute('data-route')).then(hydrate, hydrate);
} else {
  ReactDOM.createRoot(container).render(<App />);
}
